import React, { useRef, useEffect, useState } from "react";
import ProductCard from "../../components/common/ProductCard";
import productService from "../../services/product.service";

const ProductSlider = ({ 
  title = "Trending Now", 
  onNavigate, 
  onAddToCart,
  // NEW: Accept the cart props
  cartItems,
  onQuantityChange,
  onRemoveItem
}) => {
  const scrollRef = useRef(null);
  const animationRef = useRef(null);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH PRODUCTS ---------------- */
  useEffect(() => {
    let isMounted = true;

    const fetchProducts = async () => {
      try {
        const data = await productService.getAllProducts();

        if (isMounted && Array.isArray(data) && data.length > 0) {
          setProducts([...data, ...data]); // duplicate for loop
        }
      } catch (err) {
        console.error("❌ Slider fetch failed", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  /* ---------------- AUTO SCROLL ---------------- */
  useEffect(() => {
    const track = scrollRef.current;
    if (!track || products.length === 0) return;

    let scrollAmount = 0;
    const speed = 0.4;

    const scroll = () => {
      scrollAmount += speed;
      track.scrollLeft = scrollAmount;

      if (scrollAmount >= track.scrollWidth / 2) {
        scrollAmount = 0;
        track.scrollLeft = 0;
      }

      animationRef.current = requestAnimationFrame(scroll);
    };

    animationRef.current = requestAnimationFrame(scroll);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [products]);

  /* ---------------- RENDER ---------------- */
  return (
    <section className="page-section section-reveal product-slider-section">
      <h2 className="section-title">{title}</h2>

      {loading && (
        <p style={{ textAlign: "center", padding: "1rem" }}>
          Loading products...
        </p>
      )}

      {!loading && products.length === 0 && (
        <p style={{ textAlign: "center", padding: "1rem" }}>
          No products available
        </p>
      )}

      {!loading && products.length > 0 && (
        <div className="slider-container">
          <div className="slider-track" ref={scrollRef}>
            {products.map((product, index) => (
              <div
                key={`${product.product_id || product.id}-${index}`}
                className="slider-item"
              >
                <ProductCard
                  product={product}
                  productId={product.product_id || product.id}
                  onNavigate={onNavigate}
                  onAddToCart={onAddToCart}
                  
                  // NEW: Pass the props down to the card
                  cartItems={cartItems}
                  onQuantityChange={onQuantityChange}
                  onRemoveItem={onRemoveItem}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductSlider;